module.exports = __webpack_public_path__ + "static/media/45deg.e720f969.png";